/* CHQ Sticky Mini-Banner v3 — yields to mega menu */
(function(){
  if (window.__chqStickyMiniV3) return;
  window.__chqStickyMiniV3 = true;

  var BUSINESS = { open: 8, close: 17, days: [1,2,3,4,5] };

  function isEngineerOnline() {
    try {
      var fmt = new Intl.DateTimeFormat('en-US', {timeZone: 'America/Chicago', weekday: 'short', hour: 'numeric', hour12: false});
      var parts = fmt.formatToParts(new Date());
      var hour = parseInt(parts.find(function(p){return p.type==='hour';}).value, 10);
      var weekday = parts.find(function(p){return p.type==='weekday';}).value;
      var dayMap = {Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6, Sun:0};
      var dayNum = dayMap[weekday];
      return BUSINESS.days.indexOf(dayNum) !== -1 && hour >= BUSINESS.open && hour < BUSINESS.close;
    } catch(e) { return false; }
  }

  function openTidio(){
    if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') { window.tidioChatApi.open(); return; }
    var launchers = document.querySelectorAll('iframe[id^="tidio-chat"], #tidio-chat, button[id*="tidio"]');
    for (var i = 0; i < launchers.length; i++) { try { launchers[i].click(); return; } catch(e){} }
    window.location.href = '/pages/contact-us';
  }

  function init() {
    var mini = document.querySelector('[data-chq-sticky-mini]');
    if (!mini) return;
    var anchor = document.querySelector('.heading-wrapper--collection');

    function check() {
      if (anchor) {
        var rect = anchor.getBoundingClientRect();
        if (rect.bottom < 10) mini.classList.add('is-visible');
        else mini.classList.remove('is-visible');
      } else {
        if (window.scrollY > 400) mini.classList.add('is-visible');
        else mini.classList.remove('is-visible');
      }
    }
    window.addEventListener('scroll', check, {passive: true});
    window.addEventListener('resize', check, {passive: true});
    check();

    // === Yield to mega menu ===
    function bindMegaYield() {
      var navItems = document.querySelectorAll('.has-mega-menu, .navbar-item');
      navItems.forEach(function(item){
        item.addEventListener('mouseenter', function(){ mini.classList.add('chq-mega-yield'); });
        item.addEventListener('mouseleave', function(){
          // small delay so brief mouse exits don't flicker
          setTimeout(function(){
            // check if any mega menu wrapper is still being hovered
            if (!document.querySelector('.has-mega-menu:hover, .mega-menu:hover, .navbar-item:hover')) {
              mini.classList.remove('chq-mega-yield');
            }
          }, 100);
        });
      });
      // Also yield when any visible mega-menu gets hovered (the dropdown itself)
      document.addEventListener('mouseover', function(e){
        if (e.target && e.target.closest && e.target.closest('.mega-menu, .has-mega-menu')) {
          mini.classList.add('chq-mega-yield');
        }
      });
      document.addEventListener('mouseout', function(e){
        setTimeout(function(){
          if (!document.querySelector('.has-mega-menu:hover, .mega-menu:hover')) {
            mini.classList.remove('chq-mega-yield');
          }
        }, 150);
      });
    }
    bindMegaYield();

    // Engineer status
    var chatBtn = mini.querySelector('[data-chq-engineer-chat]');
    var label = mini.querySelector('[data-chq-engineer-label]');
    function updateStatus() {
      if (!chatBtn) return;
      var online = isEngineerOnline();
      chatBtn.setAttribute('data-status', online ? 'online' : 'offline');
      if (label) label.textContent = online ? 'Chat with Engineer' : 'Leave a Message';
    }
    updateStatus();
    setInterval(updateStatus, 60000);
    if (chatBtn) {
      chatBtn.addEventListener('click', function(){
        if (isEngineerOnline()) openTidio();
        else window.location.href = '/pages/contact-us#leave-message';
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
